import { StuckPoint } from './StuckPoint';
import { StuckPoints } from './StuckPoints';

export const stuckPointsRoutes = [
  { path: '', element: <StuckPoints /> },
  { path: ':id', element: <StuckPoint /> },
];
